import { Component } from '@angular/core';

@Component({
    selector: 'an-DTANFEDMyFavoriteLib',
    templateUrl: `./dt-an-myfavorite-lib.component.html`,
    styles: [],
    standalone: false
})
export class DTANFEDMyFavoriteLibComponent {

}
